import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-rates',
  imports: [],
  templateUrl: './rates.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './rates.scss',
})
export class Rates {

}
